module.exports = __webpack_public_path__ + "media/hang-up.13ba8b4c.mp3";